import { jsx } from "react/jsx-runtime";
import { Alert, spaceMixin } from "@zillow/constellation";
import styled from "styled-components";
const StyledErrorBox = styled.div.withConfig({
  displayName: "ErrorBox__StyledErrorBox",
  componentId: "sc-14hyed0-0"
})(["margin:", " auto;"], ({
  hideTopMargin
}) => hideTopMargin ? 0 : spaceMixin("sm"));
const ErrorBox = ({
  errorMessage,
  hideTopMargin = false
}) => /* @__PURE__ */ jsx(StyledErrorBox, { "data-testid": "error-message", hideTopMargin, children: /* @__PURE__ */ jsx(Alert, { appearance: "error", body: errorMessage }) });
export {
  ErrorBox as default
};
